export const AdvisorInvestorThesisPanel = ({ thesis }) => {
  if (!thesis) return null;

  return (
    <div className="rounded-[24px] border border-[#001935]/10 bg-[#001935] px-5 py-5 text-white shadow-[0_18px_36px_rgba(0,25,53,0.16)]" data-testid="signature-advisor-investor-thesis-panel">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]" data-testid="signature-advisor-investor-thesis-eyebrow">Investor thesis engine</p>
      <h4 className="mt-2 text-xl font-semibold text-white" data-testid="signature-advisor-investor-thesis-headline">{thesis.headline}</h4>
      <p className="mt-2 text-sm leading-7 text-[#dbe4f0]" data-testid="signature-advisor-investor-thesis-summary">{thesis.summary}</p>

      <div className="mt-4 grid gap-3 xl:grid-cols-2" data-testid="signature-advisor-investor-thesis-card-grid">
        {thesis.cards?.map((card, index) => (
          <div className="rounded-[18px] border border-white/10 bg-white/8 px-4 py-4" data-testid={`signature-advisor-investor-thesis-card-${index + 1}`} key={`${card.label}-${index}`}>
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#D4AF37]">{card.label}</p>
            <p className="mt-2 text-sm font-semibold leading-6 text-white">{card.value}</p>
            <p className="mt-2 text-sm leading-6 text-[#dbe4f0]">{card.rationale}</p>
          </div>
        ))}
      </div>
    </div>
  );
};